import { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useCookieConsent } from '@/hooks/useSiteSettings';

/**
 * Minimal, gold-accented cookie banner. Shown until the user has made a choice.
 * Persists via a single strictly-necessary cookie.
 */
export function CookieBanner() {
  const { hasConsented, accept, decline } = useCookieConsent();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted || hasConsented) return null;
  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-4 bottom-4 z-[55] sm:left-auto sm:right-6 sm:max-w-md"
    >
      <div className="glass rounded-xl border border-border-strong bg-bg-elevated/95 p-4 shadow-lg backdrop-blur-md">
        <div className="flex items-start gap-3">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-gold-500" aria-hidden />
          <div className="flex-1">
            <p className="text-sm font-semibold text-fg">We use cookies</p>
            <p className="mt-1 text-xs text-fg-muted">
              We use strictly-necessary cookies to remember your preferences. We never sell your data.
              <a href="/legal/cookies" className="ml-1 text-gold-500 hover:underline">
                Cookie policy
              </a>
            </p>
            <div className="mt-3 flex gap-2">
              <Button size="sm" onClick={accept}>
                Accept
              </Button>
              <Button size="sm" variant="ghost" onClick={decline}>
                Decline
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}